import * as React from 'react';
import { Image } from '@cian/ui-kit/image';
import * as style from './MapPreview.css';
import { PinIcon } from './parts/PinIcon/PinIcon';

export interface IFullAddressProps {
  mapPreview: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function MapPreview({ mapPreview, onClick }: IFullAddressProps) {
  return (
    <div className={style['map']} onClick={onClick}>
      <div className={style['map-pin']}>
        <PinIcon />
      </div>
      <Image objectFit={'cover'} src={mapPreview} />
    </div>
  );
}
